import { createStore } from "vuex";
import InfoRequestStore from "@Scripts/Stores/InfoRequestStore";

export const store = createStore({
    modules: {
        "infoRequestStore": InfoRequestStore
    }
});